import React, { useEffect } from "react";

export function useModalFocusObserver(
  modalRef: React.RefObject<HTMLDialogElement | null>,
  inputRef: React.RefObject<HTMLElement | null>,
) {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (modalRef.current?.open) {
        inputRef.current?.focus();
      }
    });

    if (modalRef.current) {
      observer.observe(modalRef.current, {
        attributes: true,
        attributeFilter: ["open"],
      });
    }

    return () => observer.disconnect();
  }, [modalRef, inputRef]);
}
